// Shared PII scrubber for free-form text that leaves the app for PostHog.
//
// Two payload kinds carry text we author rather than metadata we choose:
// exception messages (`$exception_message`) and log bodies. Both can pick up
// user-typed values by accident. This module is the single implementation so
// the two paths can't drift apart.
//
// Patterns redacted:
//   - Tokens following `name:` / `name ` → `[redacted]`
//   - Email-shaped substrings → `[email]`
//
// This is a coarse safety net, not a full PII filter. The real rule is the
// one codified in `capture-exception.ts` and `log-server.ts`: never put
// user-typed text into a message or log body in the first place — pass the
// value as a separate attribute where the typed shape can route it.
//
// Note the asymmetry in how the two callers reach this: exceptions get it via
// `before_send`, which posthog-js runs for every `$exception` event. Logs have
// no such hook (`captureLog` builds the OTLP record and buffers it directly,
// and server-side OTel has no equivalent), so `log-server.ts` /
// `log-client.ts` must call this explicitly. That makes the helper the ONLY
// guardrail on the logs path.

export function scrubPiiText(text: string): string {
  return text
    .replace(/(?<=name[:\s]+)[\p{L}-]+/giu, "[redacted]")
    .replace(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi, "[email]");
}
